import { client } from './api-client';

export const mggFetchVideoHistory = () => client.get(`mgg/history`);
export const mggSetHistoryTimeLine = (video_id, timeline_position) =>
  client.put(`mgg/history?video_id=${video_id}&timeline_position=${timeline_position}`);
